<template>
  <div class="">
    <div class="filter">
      <div class="flex " style="align-items: flex-start"><span>所属地区<i class="el-icon-arrow-right
"></i></span>
        <div class="list">
          <div class="flex" style="">
            <span @click="check(item,index,1)" :class="province_id==item.value?  'active':''"
              v-for="(item,index) in data">{{item.label}}</span>
          </div>
        </div>
      </div>
      <div class="flex" style="align-items: flex-start;"><span>年份<i class="el-icon-arrow-right
"></i></span>
        <div class="list">
          <div class="flex">
            <span @click="check(item,index,2)" :class="yearNo==index? 'active':''"
              v-for="(item,index) in data[no].children">{{item.value}}</span>
          </div>
        </div>
      </div>
      <div class="flex " style="align-items: flex-start;"><span>考生类别<i class="el-icon-arrow-right
"></i></span>
        <div class="list">
          <div class="flex">
            <span @click="check(item,index,3)" :class="typeNo==index?'active':''"
              v-for="(item,index) in data[no].children[yearNo].children">{{item.value}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: [],
        no: 12,
        province_id: 19,
        yearNo: 0,
        typeNo: 0,
        data1: [],
        conditions: {
          province_id: "19",
          type: '文科',
          score: '',
          year: '2022'
        }
      }
    },
    created() {
      this.$http.provinceLine({
        type: '文科'
      }).then(res => {
        this.data = res.data
      })
    },
    methods: {
      check(item, index, num) {
        console.log(item, index)
        // if (!item.children) {
        //   this.$message.warning('暂无数据')
        // }
        if (num == 1) {
          this.province_id = item.value
          this.conditions.province_id = item.value
          this.conditions.year = item.children[0].value
          this.conditions.type = item.children[0].children[0].value
          this.no = index
          this.yearNo = 0
          this.type = 0
        }
        if (num == 2) {
          this.yearNo = index
          this.conditions.year = item.value
          this.conditions.type = item.children[0].value
          this.typeNo = 0
        }
        if (num == 3) {
          this.typeNo = index
          this.conditions.type = item.value
        }
        // console.log(this.conditions)
        this.$emit('change', this.conditions)
      }
    }
  }
</script>

<style scoped lang="scss">
  $color: #C10B17;

  .schoolList {
    margin: 40px 0;
  }

  .flex>span {
    width: 100px;
    text-align: left;
  }

  .list {
    margin-left: 40px;
    width: 800px;
    text-align: left;

    &>div {
      margin-bottom: 23px;
    }

    /* justify-content: space-between; */
  }

  .list span {
    margin: 0px 0px 20px 0px;
    cursor: pointer;
  }

  .active {
    color: $color;
  }
</style>



// WEBPACK FOOTER //
// src/components/condition.vue